<div class="admin">
  <div class="login row d-flex flex-column justify-content-center align-items-center">
    <div class="logo d-flex align-items-center justify-contet-between">
      <a>
        <img src="../../../assets/images/MC-white.svg" />
      </a>
      <div class="slogan">
        <span class="slogan-ar"> مركز الامتياز التجاري </span>
        <span class="slogan-en"> Franchise Center </span>
      </div>
    </div>

    <div class="col-md-4">
      <form class="form login-form" [formGroup]="form_Group" (ngSubmit)="save()">
        <div *ngIf="isInvalid">
          <div class="form-group">
            <p style="padding: 0% 30%;"><i class="fa-regular fa-envelope fa-2xs"></i></p>
            <h1 class="text-center">{{invalidMessage}}</h1>
          </div>
          <div class="login-button">
            <a class="btn btn-primary btn-block" routerLink="/adminlogin">تسجيل الدخول</a>
          </div>
        </div>
        <div *ngIf="!isInvalid">
          <div class="mb-4" *ngIf="errorMessage">
            <ngb-alert type="danger" (close)="errorMessage = null">
              {{ errorMessage }}
            </ngb-alert>
          </div>
          <p class="welcome text-center">تعيين كلمه مرور</p>
          <p class="title text-center">ادخل البيانات لتعيين كلمه مرور</p>
          <p *ngIf="isPasswordChanged" class="text-center" style="color: black;font-size: 20px;">
            {{"ResetPassword.Success" |translate}}
          </p>
          <div *ngIf="!isPasswordChanged">
            <div class="form-group">
              <label for="password"> كلمة المرور الجديدة </label>
              <input [qcId]="'change-password-password'" [type]="showPassword ? 'text' : 'password'"
                formControlName="password" id="password" class="form-control" />
              <div class="input-icon" (click)="showPassword = !showPassword">
                <i class="fa-solid fa-eye"></i>
              </div>
              <div class="text-danger mt-2">
                <div *ngIf="controlHasError('required', 'password', form_Group)">
                  {{"ResetPassword.Password_Required" | translate}}
                </div>
                <div *ngIf="controlHasError('pattern', 'password', form_Group)">
                  <p class="text-danger" [innerHTML]="'ResetPassword.Password_String' | translate"></p>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="password"> تأكيد كلمة المرور الجديدة </label>
              <input [qcId]="'change-password-confirm-password'" [type]="showPassword ? 'text' : 'password'"
                formControlName="confirmPassword" id="confirmPassword" class="form-control" />
              <div class="input-icon" (click)="showPassword = !showPassword">
                <i class="fa-solid fa-eye"></i>
              </div>
              <div class="text-danger mt-2">
                <div *ngIf="controlHasError('required', 'confirmPassword', form_Group)">
                  {{"ResetPassword.ConfirmPassword_Required" | translate}}
                </div>
                <div *ngIf="controlHasError('passwordMatch', 'confirmPassword', form_Group)">
                  {{"ResetPassword.ConfirmPassword_PasswordMatch" | translate}}
                </div>
              </div>
            </div>
          </div>

          <div class="login-button">
            <button type="submit" class="btn btn-primary btn-block" *ngIf="!isPasswordChanged">تغيير</button>
            <a class="btn btn-primary btn-block mt-2" routerLink="/adminlogin" *ngIf="isPasswordChanged">تسجيل
              الدخول</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>